<template>
  <div class="publication-list" :class="[css]">
    <inner-search v-if="withSearch" :search-string.sync="searchString" />
    <!-- <div
      v-if="withSearch"
      class="list-search"
      :class="[searchActive ? 'focused' : '']"
    >
      <input
        v-model="searchString"
        type="text"
        :placeholder="localize('Search') + '...'"
        @focus="searchFocus"
        @blur="searchBlur"
      />
      <i
        @click="clearSearchString"
        :class="['mr-xs', 'fal', searchString ? 'fa-times' : 'fa-search']"
      ></i>
    </div> -->
    <h3 class="text-gray-6 pl-l" v-if="!filteredChildren.length">
      No items were found.
    </h3>
    <paginate
      v-else
      ref="paginator"
      name="filteredChildren"
      :list="filteredChildren"
      :per="12"
      tag="div"
      class="paginate-langs"
      :key="filteredChildren.length"
    >
      <div
        v-for="publication in paginated('filteredChildren')"
        :class="[
          'publication-list--item',
          'py-l',
          events ? 'is-events' : '',
          isOpen(publication.id) ? 'open ' : ''
        ]"
        :key="publication.id"
      >
        <i
          @click="togglePublication(publication.id)"
          :class="[
            'fal',
            'pointer',
            'text-blue-6',
            'text--xs',
            isOpen(publication.id) ? 'fa-minus' : 'fa-plus'
          ]"
        ></i>
        <div class="publication-list--item__wrap ml-xs">
          <h5
            @click="togglePublication(publication.id)"
            class="publication-list--item--title font-rg pointer"
            v-if="publication.title"
          >
            <span v-text="publication.title"></span>
          </h5>
          <transition name="showdown" appear>
            <div
              v-if="isOpen(publication.id)"
              class="publication-list--item__inner pt-m"
            >
              <p
                class="publication-list--item--subtitle text--s font-400"
                v-if="publication.sub_title"
                v-text="publication.sub_title"
              ></p>
              <p
                class="publication-list--item--summary pt-m"
                v-if="publication.summary"
                v-html="publication.summary"
              ></p>
              <p
                class="publication-list--item--content pt-m"
                v-if="publication.content"
                v-html="publication.content"
              ></p>
              <div
                v-if="events && publication.parsedEventDate"
                class="pt-xl event-list--item--placetime"
                :class="['text--s']"
              >
                <span>
                  <i class="fal fa-calendar-alt mr-xs"></i>
                  <span v-text="publication.parsedEventDate"></span>
                </span>
                <span v-if="publication.parsedEventLocation" class="ml-m">
                  <i class="fal fa-map-marker-alt mr-xs"></i>
                  <span v-text="publication.parsedEventLocation"></span>
                </span>
              </div>
              <div
                v-if="publication.children && publication.children.length"
                class="btn-group flex flex-row flex-wrap pt-2xl text-left"
              >
                <abtn
                  :class="['mr-xs', 'mb-xs']"
                  v-for="(button, index) in publication.children"
                  :key="index + button.title + publication.id"
                  v-bind="button"
                  mini
                  color="white"
                >
                  <span v-text="button.title"></span>
                </abtn>
              </div>
              <abtn
                v-else-if="publication.url"
                :url="publication.url"
                :class="['mt-xl']"
                link-mode
              >
                <span v-text="localize('view_publication')"></span>
              </abtn>
            </div>
          </transition>
        </div>
      </div>
    </paginate>

    <transition name="slide-up" appear>
      <div class="pager align-left pt-l" v-if="filteredChildren.length > 12">
        <paginate-links
          id="pager"
          ref="pager"
          for="filteredChildren"
          :limit="4"
          :show-step-links="true"
          @change="onLangsPageChange"
          :step-links="{ next: localize('Next'), prev: localize('Prev') }"
        ></paginate-links>
      </div>
    </transition>
  </div>
</template>
<script>
import { mapActions, mapState } from "vuex";

export default {
  props: {
    children: Array,
    title: String,
    hasSearch: {
      type: Boolean,
      default: false
    },
    css: {
      type: String,
      default: ""
    },
    events: {
      type: Boolean,
      default: false
    },
    properties: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  data() {
    return {
      openPublications: [],
      searchActive: false,
      searchString: null,
      paginate: ["filteredChildren"]
    };
  },
  mounted() {
    this.setMediaChildrenToGallery();
  },
  methods: {
    ...mapActions(["setGalleryChildren"]),
    setMediaChildrenToGallery() {
      this.$nextTick(function() {
        if (this.mediaChildren && this.mediaChildren.length) {
          this.setGalleryChildren(this.mediaChildren);
        }
      });
    },
    getOffset(el) {
      var rect = el.getBoundingClientRect(),
        scrollLeft = window.pageXOffset || document.documentElement.scrollLeft,
        scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      return { top: rect.top + scrollTop, left: rect.left + scrollLeft };
    },
    onLangsPageChange() {
      let el = this.$el.parentElement,
        offset = this.getOffset(el);
      if (el) {
        let top = offset.top - 120;
        window.scrollTo({ top, behavior: "smooth" });
      }
    },
    togglePublication(id) {
      let _pubs = _.clone(this.openPublications);
      let _i = _pubs.indexOf(id);

      if (_i > -1) {
        _pubs.splice(_i, 1);
      } else {
        _pubs.push(id);
      }
      this.$set(this, "openPublications", _pubs);
      this.$emit("content-loaded");
    },
    isOpen(id) {
      return this.openPublications.indexOf(id) > -1;
    }
  },
  computed: {
    ...mapState(["dimensions"]),
    filteredChildren() {
      if (this.searchString && this.searchString.length > 1) {
        return this.children.filter(child => {
          let __s = (child.title + child.sub_title).toLowerCase();
          return __s.indexOf(this.searchString.toLowerCase()) > -1;
        });
      }
      return this.children;
    },
    mediaChildren() {
      return _.filter(
        _.flatMap(this.children, "children"),
        child =>
          (child.url && /(vimeo|youtube)/g.test(child.url)) ||
          child.url.indexOf("/") < 0
      );
    },
    withSearch() {
      // return true;
      if (this.properties && _.has(this.properties, "hasSearch")) {
        return this.properties.hasSearch;
      }
      return this.hasSearch;
    }
  }
};
</script>
<style lang="stylus">
.showdown
  &-enter-active
  &-leave-active
    transition max-height 0.5s ease-out, padding 0.5s ease-out !important
  &-enter
  &-leave-to
    padding-top 0
    max-height 0px !important
  &-enter-to
  &-leave
    max-height 300px !important
  +portrait()
    max-height 600px
.publication-list
  // width 100%
  &--item
    text-align left
    border-bottom 1px solid rgba(blue_3, 0.5)
    _flex(row, wrap, flex-start, flex-start)
    overflow hidden
    // transition padding 0.6s ease-out-cubic
    // max-width 90%
    +below(815px)
      padding-top 15px
      padding-bottom 15px
    &__wrap
      flex 1
      max-width 90%
    & > i
      flex none
      transition transform 0.4s ease-out-cubic
      margin 3px 0 0 3px
      &.fa-minus
        transform rotate(-180deg)
      &.fa-plus
        transform rotate(-90deg)
    // & > *:not(h4):not(i)
    //   opacity 0
    //   height 0
    //   overflow hidden
    &.is-events
      padding-left 5px
      border-bottom none
      &:nth-child(even)
        background gray_1 //rgba(gray_1, 0.6)
      &:nth-child(odd)
        background rgba(lighten(gray_1, 2), 0.2) //rgba(gray_1, 0.6)
    &.open  > *
      opacity 1
      height 100%
    &:not(.is-events):first-child
      padding-top 0
    &:last-child
      border-bottom 0
    &--title
      color gray_9
    p
      &:last-child
        padding 0
</style>
